import * as React from 'react'
import { useTranslation } from 'react-i18next'

import Notification from './Notification'

import './styles.sass'
import { SingleNotificationInList } from '../../store/member/memberTypings'
import { useEffect, useRef, useState } from 'react'
import { notification_read } from '../../api/member'

export interface Props {
    notifications: SingleNotificationInList[]
    trigger: React.MutableRefObject<HTMLDivElement>
    isListEnded: boolean
}

const List = ({ notifications, trigger, isListEnded }: Props) => {
    const [t] = useTranslation()

    const [readNotifications, setReadNotifications] = useState<string[]>([])
    const timeoutRef = useRef(null)

    useEffect(() => {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = setTimeout(() => {
            if (readNotifications.length) {
                notification_read({ ids: readNotifications.join(',') })
                setReadNotifications([])
            }
        }, 1000)
        return () => {
            if (readNotifications.length) {
                notification_read({ ids: readNotifications.join(',') })
                setReadNotifications([])
            }
        }
    }, [readNotifications])

    return (
        <div>
            <div className="pageRow">
                <div className="pageSubTitle">{t('Notification List')}</div>
            </div>
            <div className="notificationsList">
                {notifications.length > 0 ? (
                    notifications
                        // .filter((notif) => notif.type !== 'ephemeral')
                        .map((notification, index) => (
                            <React.Fragment key={notification.id}>
                                <Notification notification={notification} setReadNotifications={setReadNotifications} />
                                {index == notifications.length - 1 && !isListEnded ? <div ref={trigger} /> : <></>}
                            </React.Fragment>
                        ))
                ) : (
                    <></>
                )}
            </div>
        </div>
    )
}

export default List
